import React,{useState} from 'react'
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

function SearchBar({handleSearchChange,searchCriteria,handleSearchCriteriaChange,handleReset}) {
    const [searchTerm, setSearchTerm] = useState('');

    const handleDateChange = (selectedDate) => {
        setSearchTerm(selectedDate[0].toISOString().split('T')[0]);
    };
    const handleSearchTermChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleTxtReset = ()=>{
        setSearchTerm('')
        handleReset()
    }

    return (
        <div style={{ flexShrink: 0 }}>
            {/* Search Input */}
            <div className="input-group input-group-sm mb-3">
                <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-search text-muted"></i>
                </span>
                {searchCriteria === 'date' ? (
                    <Flatpickr
                        className="form-control form-control-sm border-start-0 bg-light"
                        value={searchTerm}
                        onChange={handleDateChange}
                        placeholder="Select date..."
                        options={{ 
                            dateFormat: 'Y-m-d',
                            maxDate: 'today',
                            allowInput: true,
                            clickOpens: true,
                            appendTo: document.body,
                            static: false
                        }}
                    />
                ) : (
                    <input
                        type="text"
                        className="form-control form-control-sm border-start-0 bg-light"
                        placeholder="Search contacts..."
                        onChange={handleSearchTermChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchChange(searchTerm);
                            }
                        }}
                        value={searchTerm}
                    />
                )}
                <button 
                    className="btn btn-primary btn-sm text-white" 
                    onClick={() => handleSearchChange(searchTerm)}
                    type="button"
                >
                    <i className="bi bi-search text-white"></i>
                </button>
                {searchTerm.length > 0 && (
                    <button 
                        className="btn btn-outline-secondary btn-sm" 
                        onClick={handleTxtReset}
                        type="button"
                    >
                        <i className='bi bi-x-lg'></i>
                    </button>
                )}
            </div>

            {/* Filter Options - 2x2 Grid */}
            <div className="row g-2">
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="firstName"
                            value="firstName"
                            checked={searchCriteria === 'firstName'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="firstName">
                            First Name
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="lastName"
                            value="lastName"
                            checked={searchCriteria === 'lastName'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="lastName">
                            Last Name
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="cell"
                            value="cell"
                            checked={searchCriteria === 'cell'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="cell">
                            Phone
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="searchCriteria"
                            id="searchDate"
                            value="date"
                            checked={searchCriteria === 'date'}
                            onChange={handleSearchCriteriaChange}
                        />
                        <label className="form-check-label small text-muted" htmlFor="searchDate">
                            Date
                        </label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchBar